// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"469":"npm.simplelightbox","812":"npm.swiper"}[chunkId] + ".js");